import { ReactElement } from 'react'
import ReactPlayer from 'react-player'
import { useHistory } from 'react-router-dom'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../../../redux/store'
import { getSubjectLogo } from '../../../../../helpers'
import { SubHeader } from '../../../../../components'
import { SubjectWrapper } from '../subcomponents'
import useBreakpoint from 'use-breakpoint'
import BREAKPOINTS from '../../../../../const/breakpoint'
import { VideoPlayerWrapper } from '../subcomponents'
import { determineHeight, determineWidth } from '../../helpers'

const Materials = (): ReactElement => {
  const { subjectName = '', selectedMaterial } = useSelector(
    (state: RootState) => ({
      subjectName: state.learn?.chapters?.subjectName,
      selectedMaterial: state.learn?.chapters?.selectedMaterial
    }),
    shallowEqual
  )
  const history = useHistory()
  const { breakpoint } = useBreakpoint(BREAKPOINTS)
  const logo = getSubjectLogo({
    subject: subjectName
  })

  return (
    <SubjectWrapper id="container">
      <SubHeader
        title={selectedMaterial?.courseName || ''}
        handleBack={() => {
          history.goBack()
        }}
        logo={logo}
        subTitle={selectedMaterial?.title}
      />
      <VideoPlayerWrapper>
        <ReactPlayer
          config={{ file: { attributes: { controlsList: 'nodownload' } } }}
          url={selectedMaterial?.description}
          controls
          width={determineWidth(breakpoint)}
          height={determineHeight(breakpoint)}
        />
      </VideoPlayerWrapper>
    </SubjectWrapper>
  )
}

export default Materials
